import React, { useState, useEffect, useCallback } from "react"
import {
    ButtonField,
    InputField,
    Pagination,
    PaginationBar,
    PaginationBarLeft,
    PaginationBarRight,
    SelectField
} from '@wk/components-react16';
import HttpService from '../../config/http.service';
import { API_USER } from '../../config/constants';
import { Toast } from "../../services";
import { hideLoading, showLoading } from "../../store/authReducer";
import { useDispatch } from "react-redux";


const UserAccessOverview = ({data, editUser, triggerGetUserList}:any) => {
     const dispatch = useDispatch();
    const { roleList, projectList } = data;
    const [pagination, setPagination] = useState({ pageIndex: 1, pageSize: 10, pageCount: 0, totalCount: 0 });
    // const searchRef = useRef<SearchSuggestionsWrapper>(null);
    
    const [filter, setFilter] = useState({
                username: "",
                project: "",
                role: "",
                status: 'active'
            });
    const [userList, setUserList] = useState<any[]>([]);

    const getUsers = useCallback((page: number = 1, size: number = 10) => {
        let payload = {
            pageSize: size,
            pageNumber: page,
            filter: {
                username: filter.username,
                project: filter.project,
                role: filter.role,
                status: filter.status === 'active' ? true : false
            }
        }
        dispatch(showLoading());
        HttpService.postRequest(`${API_USER.GET_USER_LIST}`, payload).then(
            (res: any) => {
                dispatch(hideLoading());
                setUserList(res.data);
                setPagination({
                    pageIndex: page,
                    pageSize: size,
                    pageCount: Math.ceil(res.totalCount / size),
                    totalCount: res.totalCount
                });
            },
            (err: any) => {
                dispatch(hideLoading());
                Toast(err.message, "error")
            },
        )
    }, [filter, dispatch]);
    
    const pageChange = (event: any) => {
        getUsers(event, pagination.pageSize);
    }
    
    const onSelect = (event: any) => {
        const newOption = parseInt(event.target.value, 10);
        getUsers(1, newOption);
    }

    const getTopItem = () => {
        return 1 + pagination.pageSize * (pagination.pageIndex - 1);
    }

    const onfilter = () => {
        getUsers(1, pagination.pageSize);
    }
    const clearForm = () => {
        filter.username = "";
        filter.project = "";
        filter.role = "";
        filter.status = "active";
        setFilter({...filter});
        getUsers(1, pagination.pageSize); 
    }
    // useEffect(() => {
    //     getUsers();
    // }, []);
    useEffect(() => {
        if(triggerGetUserList) {
            getUsers();
        }
    }, [triggerGetUserList, getUsers]);

  return (
    <>
        <div className="wk-row">
            <div className="wk-col-2">
                <InputField
                    label="User Name"
                    labelFor="username"
                    size="small">
                    <input
                        type="text"
                        id="username"
                        name="username"
                        value={filter.username}
                        onChange={(e) => setFilter({...filter, username: e.target.value})}
                    />
                </InputField>
            </div>
            <div className="wk-col-2">
                <SelectField
                    label="Projects"
                    labelFor="projects"
                    size="small">
                    <select id="projects" name="projects" value={filter.project} onChange={(e) => setFilter({...filter, project: e.target.value})}>
                        <option value="0">--Select Project--</option>
                        {projectList && projectList.map((project: any) => (
                            <option key={project.id} value={project.name}>{project.name}</option>
                        ))}
                    </select>
                </SelectField>
            </div>
            <div className="wk-col-2">
                <SelectField
                    label="Roles"
                    labelFor="roles"
                    size="small">
                    <select id="roles" name="roles" value={filter.role} onChange={(e) => setFilter({...filter, role: e.target.value})}>
                        <option value="">--Select Role--</option>
                        {roleList && roleList.map((role: any) => (
                            <option key={role.id} value={role.name}>{role.name}</option>
                        ))}
                    </select>
                </SelectField>
            </div>
            <div className="wk-col-2">
                <SelectField
                    label="Status"
                    labelFor="status"
                    size="small">
                    <select id="Status" name="status" value={filter.status} onChange={(e) => setFilter({...filter, status: e.target.value})}>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                    </select>
                </SelectField>
            </div>
            <div className="wk-col-2 pt-20">
                 <ButtonField size={'small'}>
                    <button type="button" style={{ marginRight: '5px' }} onClick={onfilter}>
                        Filter
                    </button>
                </ButtonField>
                 <ButtonField size={'small'}>
                    <button type="button" style={{ marginRight: '5px' }} onClick={clearForm}>
                        Clear
                    </button>
                </ButtonField>
            </div>
        </div>
        <div className="wk-row mt-10">
                <div className="wk-col-12">
                    <table className="wk-table wk-table-bordered wk-table-small">
                        <thead>
                            <tr>
                                <th>User Name</th>
                                <th>Projects</th>
                                <th>Role</th>
                                <th>Status</th>
                                <th style={{ width: '80px' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {userList.length > 0 ? (
                                 userList.map((user: any) => (
                                <tr key={user.id}>
                                    <td>{user.username}</td>
                                    <td>
                                        {user.project}
                                    </td>
                                    <td>
                                        {user.role}
                                    </td>
                                    <td>
                                        {user.status}
                                    </td>
                                    <td>
                                        <span className="wk-icon-pencil mr-10 cursor" title="Edit role"
                                            onClick={() => editUser({uId: user.id})}></span>
                                    </td>
                                </tr>
                            ))
                            ) : (
                                <tr>
                                    <td colSpan={5} style={{ textAlign: 'center' }}>No users found</td>
                                </tr>
                            )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
             <div className="mt-5">
                {userList?.length > 0 ? (
                    <PaginationBar>
                        <PaginationBarLeft>
                            {getTopItem()} - {(pagination.pageSize * pagination.pageIndex) > pagination.totalCount ? pagination.totalCount : (pagination.pageSize * pagination.pageIndex)} of{' '}
                            {pagination.totalCount} results{' '}
                        </PaginationBarLeft>
                        <PaginationBarRight>
                            <SelectField size="small">
                                <select onChange={(event: any) => onSelect(event)} value={pagination.pageSize}>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </SelectField>
                            <Pagination
                                pageIndex={pagination.pageIndex}
                                pageCount={pagination.pageCount}
                                controlMode='controlled'
                                onUserRequest={(event: any) => pageChange(event)}></Pagination>
                        </PaginationBarRight>
                    </PaginationBar>
                ) : null}
            </div>
    </>
  );
}

export default UserAccessOverview;